import * as FilePond from 'filepond';
import 'filepond/dist/filepond.min.css';

export class fileUpload {
  constructor() {
    const fileUploads: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[type="file"]');

    fileUploads?.forEach(fileUpload => {
      FilePond.create(fileUpload, {
        allowProcess: false,
        storeAsFile: true,
        labelIdle: 'Dateien per Drag & Drop hier ablegen oder <span class="filepond--label-action">Durchsuchen</span>'
      });
    });
  }
}

new fileUpload();
